// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader__loader___J9UzY","loader__indicator":"loader__loader__indicator___20p7V","fade":"loader__fade___17Xe9"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Loader/loader.scss
// module id = 125
// module chunks = 0